import React from 'react';
import { connect } from 'react-redux';
import { updateUserInputType } from '../ui-action';

class UserInputUpdater extends React.PureComponent { 
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const { device } = this.props;
        document.body.addEventListener('click', function () {
            // on mousedown add gating class to disable focus outline
            document.body.classList.remove('using-keyboard');
            document.body.classList.remove('using-touchscreen');  
            document.body.classList.add('using-mouse');
            //updateInputType('mouse');   
        });
    
        document.body.addEventListener('keydown', function () {
                // remove gating class when keyboard used
            document.body.classList.remove('using-mouse');
            document.body.classList.remove('using-touchscreen');
            document.body.classList.add('using-keyboard');
            //updateInputType('keyboard');
        });
    
        document.body.addEventListener('touchstart', function () {
            document.body.classList.remove('using-mouse');
            document.body.classList.remove('using-keyboard');
            document.body.classList.add('using-touchscreen');
            //updateInputType('touch');
        });
        //default class based on device
        document.body.classList.add(`using-${device ==='desktop'?'mouse':'touchscreen'}`)
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({
    device: state.ui.device
});

const mapDispatchToProps = (dispatch) => ({
    updateInputType: (type) => {
        dispatch(updateUserInputType(type))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserInputUpdater);
